/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React, { KeyboardEvent, MouseEvent } from 'react';
import { ComponentDetailsVersionsBadgeProps } from './ComponentDetailsVersionsBadge.props';

/**
 * Component details versions badge.
 * @param {ComponentDetailsVersionsBadgeProps} props Component details versions badge props.
 * @export
 * @returns {JSX.Element} The `<ComponentDetailsVersionsBadge />` component.
 */
export const ComponentDetailsVersionsBadge = (props: ComponentDetailsVersionsBadgeProps): JSX.Element => {
  const { label, isSelected, updateVersion } = props;

  const setSelectedMouseHandler = (event: MouseEvent<HTMLDivElement>): void => {
    updateVersion(label);
  };

  const setSelectedKeyboardHandler = (event: KeyboardEvent<HTMLDivElement>): void => {
    // Keys which should navigate user to the segment.
    const navigateKeys = ['Enter', 'Space'];
    if (navigateKeys.includes(event.code)) {
      updateVersion(label);
    }
  };

  return (
    <div
      className={`component-details__versions-badge ${isSelected ? 'versions-badge-selected' : ''}`}
      onClick={setSelectedMouseHandler}
      onKeyDown={setSelectedKeyboardHandler}
      role="link"
      tabIndex={0}
    >
      <span className="component-details__versions-badge-label">{label}</span>
    </div>
  );
};
